import {BaseSyntheticEvent, FC, useEffect, useState} from 'react'
import styles from './index.module.css'
import {i18n} from '../../translate/i18n'

import Swal from 'sweetalert2'
import {Input} from '../Input/Input'
import {Button} from '../Button/Button'
import {POST} from '../../services/api'
import usePluginsSpace from '../../hooks/usePluginSpace'
import useModals from '../../hooks/useModals'
import {Loading} from '../Loading/Loading'
import uuid from 'react-uuid'

type ContentModalImageIAType = {
  imageReferenceDefault: string | File | null
  setImage: (url: string) => void
  description: string
  imageIaSelected: ImageIAResponseType | undefined
  setImageIaSelected: (newImage: ImageIAResponseType) => void
}

export type ImageIAResponseType = {
  imageFileName: string
  space: number
  url: string
  prompt: string
  eTag: string
}

type ImageCopiedType = {
  imageFileName: string
  url: string
  status: string
}

const ContentModalImageIA: FC<ContentModalImageIAType> = ({
  imageReferenceDefault,
  setImage,
  description,
  imageIaSelected,
  setImageIaSelected,
}) => {
  const [urlImagesIA, setUrlImagesIA] = useState<ImageIAResponseType[]>([])
  const [imageReference, setImageReference] = useState<File | string | null>(imageReferenceDefault)
  const [descriptionIA, setDescriptionIA] = useState<string>(description)
  const [qtdIAImages, setQtdIAImages] = useState(1)
  const [loading, setLoading] = useState(false)
  const [loadingDescription, setLoadingDescription] = useState(false)
  const {pluginSpace} = usePluginsSpace()
  const {showWrapperModal, closeWrapperModal} = useModals()

  const generateImages = async () => {
    try {
      setLoading(true)
      const prompt = `Gere uma imagem a partir da seguinte descrição: ${descriptionIA}.`
      let promptCodense: {success: boolean; data: string} | undefined

      // Validar o tamanho da descrição do prompt
      if (prompt.length > 512) {
        promptCodense = await POST(`/structure-correction-ia/condensePrompt`, {
          prompt: !prompt
            ? `Gere uma imagem a partir da seguinte descrição: ${descriptionIA}.`
            : prompt,
        }).catch((e) => {
          console.log(e)
        })

        // Adiciona um delay antes de verificar a resposta
        await new Promise((resolve) => setTimeout(resolve, 3000)) // 2 segundos de espera
        console.log(promptCodense?.success)

        if (!promptCodense || !promptCodense?.success) {
          console.log('Processo de condense falhou')
          closeWrapperModal()
          Swal.fire({
            icon: 'warning',
            title: 'Descrição muito longa',
            text: 'A descrição deve ter no máximo 512 caracteres.',
          })
          setLoading(false)
          return
        }
      }

      console.log(promptCodense?.data)

      const timeoutPromise = new Promise(
        (_, reject) => setTimeout(() => reject(new Error('Timeout')), 100000) //
      )

      //Prosegue com a geração da imagem com o prompt reduzido ou o original
      const requestPromise = POST(`/structure-correction-ia/converse-textImageGeneration`, {
        modelId: 'amazon.titan-image-generator-v1',
        prompt:
          promptCodense?.data ||
          `Gere uma imagem a partir da seguinte descrição: ${descriptionIA}.`,
        typeCorrectionStructure: 'generate-image',
        numberOfImages: qtdIAImages,
      })

      const res: any = await Promise.race([requestPromise, timeoutPromise])

      if (res && res.data && res?.data.length) {
        setUrlImagesIA(res.data)
      } else {
        setUrlImagesIA([])
        closeWrapperModal()
        Swal.fire({
          icon: 'error',
          title: 'Falha ao gerar imagens',
          text: 'Revise a descrição informada!',
        }).then(() => {
          showWrapperModal(i18n.t('smart_order.create_image_ia'))
        })
      }
      setLoading(false)
    } catch (e: any) {
      if (e.message === 'Timeout') {
        Swal.fire({
          icon: 'warning',
          title: 'Tempo excedido',
          text: 'A geração da imagem demorou mais que o esperado.',
        })
      }
      setLoading(false)
      closeWrapperModal()
      Swal.fire({
        icon: 'error',
        title: 'Falha ao gerar imagens',
        text: e || 'Revise a descrição informada!',
      }).then(() => {
        showWrapperModal(i18n.t('smart_order.create_image_ia'))
      })
    }
  }

  const generateDescriptionByImage = async (imageToAnalyse: string) => {
    try {
      const bucket = 'img.ninegrid.com'
      const pathfileArray = imageToAnalyse.split('img.ninegrid.com/')[1].split('/')
      const sourcePathS3 = `${pathfileArray[0]}/${pathfileArray[1]}`
      const nameFile = pathfileArray[2]
      setLoadingDescription(true)
      const res = await POST(`/structure-correction-ia/analyzeImage`, {
        bucket,
        nameFile,
        sourcePathS3,
      })

      // Adiciona um delay antes de verificar a resposta
      await new Promise((resolve) => setTimeout(resolve, 3000)) // 2 segundos de espera
      console.log(res?.success)

      if (!res?.data || typeof res.data !== 'string') {
        setLoadingDescription(false)
        return
      }

      const MAX_LENGTH = 512
      const truncatedDescription =
        res.data.length > MAX_LENGTH ? res.data.substring(0, MAX_LENGTH) : res.data

      setDescriptionIA(truncatedDescription)

      //if(res && res.data && typeof res.data === 'string') setDescriptionIA(truncatedDescription)
      setLoadingDescription(false)
    } catch (e) {
      setLoadingDescription(false)
      console.log(e)
    }
  }

  const uploadImageAndGenerateDescription = async () => {
    if (imageReference) {
      const formData = new FormData()
      formData.append('file', imageReference)
      formData.append('nameImage', `product-${uuid()}.jpg`)
      setLoadingDescription(true)
      const imageRes = await POST('/upload-images/upload-one', formData)
      if (imageRes?.image) {
        setImage(imageRes.image)
        await generateDescriptionByImage(imageRes?.image)
      }
    }
  }

  useEffect(() => {
    if (typeof imageReference === 'string' && imageReference.includes('img.ninegrid.com/')) {
      //Se existe uma descrição e essa possui mais de 200 caracteres, não faz a chamada para gerar a descrição
      if (descriptionIA && descriptionIA.length > 200) {
        setLoadingDescription(false)
        return
      }
      //Se a imagem já foi gerada, não faz a chamada para gerar a descrição
      if (urlImagesIA.some((img) => img.url === imageReference)) {
        setLoadingDescription(false)
        return
      }
      //Caso não atenda nenhum dos ifs acima, faz a chamada para gerar a descrição
      generateDescriptionByImage(imageReference)
    } else if (typeof imageReference === 'object' && imageReference?.name) {
      uploadImageAndGenerateDescription()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageReference])

  const saveSelectedImages = async () => {
    if (!imageIaSelected) {
      closeWrapperModal()
      Swal.fire({
        icon: 'warning',
        title: 'Você não selecionou nenhuma imagem',
      }).then(() => {
        showWrapperModal(i18n.t('smart_order.create_image_ia'))
      })
      return
    }
    try {
      setLoading(true)
      const imagesDelete = urlImagesIA.filter((img) => img.url !== imageIaSelected.url)
      const res = await POST(`/structure-correction-ia/converse-sanitizeRepository`, {
        destinationBucketName: 'img.ninegrid.com',
        sourcebucketName: 'iagenerative.ninegrid.com',
        sourcePathS3: `images/output/${imageIaSelected.space}`,
        nameFile: imageIaSelected.imageFileName,
        destinationPathS3: `${pluginSpace.subdomain}/product_${pluginSpace.type}`,
        nameNewFile: imageIaSelected.imageFileName,
        imageCopy: [
          {
            imageFileName: imageIaSelected.imageFileName,
            eTag: imageIaSelected.eTag,
            url: imageIaSelected.url,
            space: imageIaSelected.space,
          },
        ],
        imagesDelete,
      })
      setLoading(false)
      if (res && res.data && res.data.length) {
        const imageCopied = res.data.find((img: ImageCopiedType) => img.status === 'copied')
        if (imageCopied) setImage(imageCopied.url)
        setUrlImagesIA([])
        closeWrapperModal()
      } else {
        closeWrapperModal()
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Falha ao salvar imagem gerada',
        }).then(() => {
          showWrapperModal(i18n.t('smart_order.create_image_ia'))
        })
      }
    } catch (e: any) {
      setLoading(false)
      closeWrapperModal()
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e || 'Falha ao salvar imagem gerada',
      }).then(() => {
        showWrapperModal(i18n.t('smart_order.create_image_ia'))
      })
    }
  }

  return (
    <div className='d-flex flex-row w-100 mt-4 gap-4'>
      <div className={`${styles.columnIaModal}`} style={{width: '35%'}}>
        {loadingDescription ? (
          <div
            className='d-flex flex-column justify-content-center align-items-center gap-2'
            style={{height: '35rem'}}
          >
            <div>
              <Loading />
            </div>
            <div>
              <span style={{fontSize: '14px'}}>
                Aguarde, estamos gerando a descrição apartir da imagem selecionada...
              </span>
            </div>
          </div>
        ) : (
          <>
            <Input
              inputAttr={{
                type: 'image',
              }}
              value={imageReference}
              change={(value: BaseSyntheticEvent) => {
                setImageReference(value ? value.target.files[0] : null)
              }}
            />
            <Input
              inputAttr={{
                type: 'textarea',
              }}
              placeholder='Descrição'
              label='Descrição'
              value={descriptionIA}
              change={(value: string) => {
                setDescriptionIA(value)
              }}
              maxCaracteres={512}
              rows={5}
            />
            <div className='w-100 d-flex flex-row justify-content-center mt-3'>
              <Button
                text={i18n.t('smart_order.generate_description')}
                color='info'
                size='small'
                horizontalPadding={5}
                svgIcon={
                  <svg
                    width='15'
                    height='15'
                    viewBox='0 0 15 15'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M6.39844 1.92578L6.78125 0.886719C6.80859 0.804688 6.89062 0.75 7 0.75C7.08203 0.75 7.16406 0.804688 7.19141 0.886719L7.57422 1.92578L8.61328 2.30859C8.69531 2.33594 8.75 2.41797 8.75 2.5C8.75 2.60938 8.69531 2.69141 8.61328 2.71875L7.57422 3.10156L7.19141 4.11328C7.16406 4.19531 7.08203 4.25 7 4.25C6.89062 4.25 6.80859 4.19531 6.78125 4.11328L6.39844 3.10156L5.38672 2.71875C5.30469 2.69141 5.25 2.60938 5.25 2.5C5.25 2.41797 5.30469 2.33594 5.38672 2.30859L6.39844 1.92578ZM12.6055 2.0625L9.59766 5.07031L10.5547 6.02734L13.5625 3.01953L12.6055 2.0625ZM2.1875 12.5078L3.11719 13.4375L9.625 6.95703L8.66797 6L2.1875 12.5078ZM11.6758 1.16016C12.1953 0.640625 13.0156 0.640625 13.5352 1.16016L14.4648 2.08984C14.9844 2.60938 14.9844 3.42969 14.4648 3.94922L4.04688 14.3672C3.52734 14.8867 2.70703 14.8867 2.1875 14.3672L1.25781 13.4375C0.738281 12.918 0.738281 12.0977 1.25781 11.5781L11.6758 1.16016ZM0.191406 3.97656L1.75 3.375L2.32422 1.84375C2.35156 1.70703 2.48828 1.625 2.625 1.625C2.73438 1.625 2.87109 1.70703 2.89844 1.84375L3.5 3.375L5.03125 3.97656C5.16797 4.00391 5.25 4.14062 5.25 4.25C5.25 4.38672 5.16797 4.52344 5.03125 4.55078L3.5 5.125L2.89844 6.68359C2.87109 6.79297 2.73438 6.875 2.625 6.875C2.48828 6.875 2.35156 6.79297 2.32422 6.68359L1.75 5.125L0.191406 4.55078C0.0820312 4.52344 0 4.38672 0 4.25C0 4.14062 0.0820312 4.00391 0.191406 3.97656ZM9.81641 10.9766L11.375 10.375L11.9492 8.84375C11.9766 8.70703 12.1133 8.625 12.25 8.625C12.3594 8.625 12.4961 8.70703 12.5234 8.84375L13.125 10.375L14.6562 10.9766C14.793 11.0039 14.875 11.1406 14.875 11.25C14.875 11.3867 14.793 11.5234 14.6562 11.5508L13.125 12.125L12.5234 13.6836C12.4961 13.793 12.3594 13.875 12.25 13.875C12.1133 13.875 11.9766 13.793 11.9492 13.6836L11.375 12.125L9.81641 11.5508C9.70703 11.5234 9.625 11.3867 9.625 11.25C9.625 11.1406 9.70703 11.0039 9.81641 10.9766Z'
                      fill='white'
                    />
                  </svg>
                }
                btnAttr={{
                  type: 'button',
                }}
                click={async () => await generateDescriptionByImage(imageReference as string)}
                btnClass='fw-bolder me-3 d-flex flex-row gap-2 align-items-center'
                txtClass='text-nowrap text-white'
                outline={false}
                disabled={loading || loadingDescription}
              />
            </div>

            <Input
              inputAttr={{
                type: 'select',
              }}
              label={i18n.t('smart_order.image_qtd_ia')}
              options={[
                {select: '1', value: '1'},
                {select: '2', value: '2'},
                {select: '3', value: '3'},
                {select: '4', value: '4'},
              ]}
              value={qtdIAImages.toString()}
              change={(value: string) => {
                setQtdIAImages(parseInt(value))
              }}
            />
            <div className='w-100 d-flex flex-row justify-content-center mt-3'>
              <Button
                text={i18n.t('smart_order.generate_images')}
                color='info'
                size='small'
                horizontalPadding={5}
                svgIcon={
                  <svg
                    width='15'
                    height='15'
                    viewBox='0 0 15 15'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M6.39844 1.92578L6.78125 0.886719C6.80859 0.804688 6.89062 0.75 7 0.75C7.08203 0.75 7.16406 0.804688 7.19141 0.886719L7.57422 1.92578L8.61328 2.30859C8.69531 2.33594 8.75 2.41797 8.75 2.5C8.75 2.60938 8.69531 2.69141 8.61328 2.71875L7.57422 3.10156L7.19141 4.11328C7.16406 4.19531 7.08203 4.25 7 4.25C6.89062 4.25 6.80859 4.19531 6.78125 4.11328L6.39844 3.10156L5.38672 2.71875C5.30469 2.69141 5.25 2.60938 5.25 2.5C5.25 2.41797 5.30469 2.33594 5.38672 2.30859L6.39844 1.92578ZM12.6055 2.0625L9.59766 5.07031L10.5547 6.02734L13.5625 3.01953L12.6055 2.0625ZM2.1875 12.5078L3.11719 13.4375L9.625 6.95703L8.66797 6L2.1875 12.5078ZM11.6758 1.16016C12.1953 0.640625 13.0156 0.640625 13.5352 1.16016L14.4648 2.08984C14.9844 2.60938 14.9844 3.42969 14.4648 3.94922L4.04688 14.3672C3.52734 14.8867 2.70703 14.8867 2.1875 14.3672L1.25781 13.4375C0.738281 12.918 0.738281 12.0977 1.25781 11.5781L11.6758 1.16016ZM0.191406 3.97656L1.75 3.375L2.32422 1.84375C2.35156 1.70703 2.48828 1.625 2.625 1.625C2.73438 1.625 2.87109 1.70703 2.89844 1.84375L3.5 3.375L5.03125 3.97656C5.16797 4.00391 5.25 4.14062 5.25 4.25C5.25 4.38672 5.16797 4.52344 5.03125 4.55078L3.5 5.125L2.89844 6.68359C2.87109 6.79297 2.73438 6.875 2.625 6.875C2.48828 6.875 2.35156 6.79297 2.32422 6.68359L1.75 5.125L0.191406 4.55078C0.0820312 4.52344 0 4.38672 0 4.25C0 4.14062 0.0820312 4.00391 0.191406 3.97656ZM9.81641 10.9766L11.375 10.375L11.9492 8.84375C11.9766 8.70703 12.1133 8.625 12.25 8.625C12.3594 8.625 12.4961 8.70703 12.5234 8.84375L13.125 10.375L14.6562 10.9766C14.793 11.0039 14.875 11.1406 14.875 11.25C14.875 11.3867 14.793 11.5234 14.6562 11.5508L13.125 12.125L12.5234 13.6836C12.4961 13.793 12.3594 13.875 12.25 13.875C12.1133 13.875 11.9766 13.793 11.9492 13.6836L11.375 12.125L9.81641 11.5508C9.70703 11.5234 9.625 11.3867 9.625 11.25C9.625 11.1406 9.70703 11.0039 9.81641 10.9766Z'
                      fill='white'
                    />
                  </svg>
                }
                btnAttr={{
                  type: 'button',
                }}
                click={async () => await generateImages()}
                btnClass='fw-bolder me-3 d-flex flex-row gap-2 align-items-center'
                txtClass='text-nowrap text-white'
                outline={false}
                disabled={loading || loadingDescription}
              />
            </div>
          </>
        )}
      </div>
      <div
        className={`${styles.columnIaModal}`}
        style={{width: '65%', justifyContent: 'space-between', alignItems: 'center'}}
      >
        {loading ? (
          <div
            className='d-flex flex-column justify-content-center align-items-center gap-2'
            style={{height: '35rem'}}
          >
            <div>
              <Loading />
            </div>
            <div>
              <span style={{fontSize: '14px'}}>Aguarde, estamos gerando a(s) imagen(s)...</span>
            </div>
          </div>
        ) : (
          <>
            <div className={styles.imagesIaModal}>
              {urlImagesIA.map((imageIa, index) => (
                <div className={styles.image} key={index}>
                  <div className={styles.checkboxImage}>
                    <label className={`form-check `}>
                      <input
                        id={`input-image-ia-${index}`}
                        name='input-image-ia'
                        key={`input-image-ia-${index}`}
                        type='checkbox'
                        checked={imageIaSelected && imageIa.url === imageIaSelected.url}
                        className={`form-check-input`}
                        onChange={(e) => {
                          setImageIaSelected(imageIa)
                        }}
                      />
                      <span className={`form-check-label fw-normal text-gray-800 ms-1`}></span>
                    </label>
                  </div>
                  <img
                    className='rounded'
                    src={imageIa.url}
                    alt={`generated-${index}`}
                    style={{objectFit: 'cover', width: '100%', height: '100%'}}
                    onClick={(e) => {
                      setImageIaSelected(imageIa)
                    }}
                  />
                </div>
              ))}
            </div>
            <div className='d-flex flex-row gap-8 justify-content-center mt-4'>
              {urlImagesIA.length > 0 && (
                <>
                  <Button
                    text={i18n.t('smart_order.cancel')}
                    color='dark'
                    size='small'
                    horizontalPadding={5}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={async () => await generateImages()}
                    btnClass='fw-bolder'
                    txtClass='text-nowrap'
                    outline
                    disabled={loading || loadingDescription}
                  />
                  <Button
                    text={i18n.t('smart_order.save_image_selected')}
                    color='dark'
                    size='small'
                    horizontalPadding={5}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={async () => await saveSelectedImages()}
                    btnClass='fw-bolder'
                    txtClass='text-nowrap'
                    disabled={loading || loadingDescription}
                  />
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export {ContentModalImageIA}
